<template>
  <div class="login">
    <div class="container">
      <div class="login__header">
        <img class="login__logo" src="@images/logo.png" alt="logo">
      </div>
    </div>
    <div class="login__wrapper">
      <div class="container">
        <form class="login__form" @submit.prevent="send">
          <h1>Log In</h1>
          <ui-input
              :type="'email'"
              :placeholder="'Email'"
              :rules="[isEmail]"
              v-model="email"
          />
          <ui-input
              :type="'password'"
              :placeholder="'Password'"
              :rules="[required]"
              v-model="password"
          />
          <button class="login__button" type="submit" :disabled="!isFormValid">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M8.33331 14.1666L12.5 9.99992L8.33331 5.83325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.5 10H2.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.5 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Log In
          </button>
        </form>
      </div>
    </div>
    <div class="login__footer">
      <p class="login__footer-text">© {{ actualYear }} INFOGUARDS LTD. All rights reserved</p>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {ElNotification} from "element-plus";
import {isEmail, isPasswordValid, required} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";

const email = ref('')
const password = ref('')

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true &&
    isPasswordValid(password.value) === true
  )
})

const actualYear = computed(() => new Date().getFullYear())

const send = () => {
  ElNotification({
    message: 'This account does not exist.',
    type: 'error'
  })
}
</script>

<style lang="scss" scoped>
.login {
  background-image: url(@images/mainBg.png);
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  background-position: center;
  height: 100vh;

  &__header {
    padding-block: 32px;
  }

  &__footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #A05718;
    padding-block: 15px;
    display: flex;
    align-items: center;
    justify-content: center;

    &-text {
      color: #FFF;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  &__logo {
    width: 105px;
  }

  &__wrapper {
    display: grid;
    place-items: center;
  }

  &__form {
    margin-top: 175px;
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-inline: auto;

    & h1 {
      color: #FFF;
      font-size: 42px;
      font-weight: 700;
    }

    & p {
      font-family: Inter, sans-serif;
      color: #000;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
    }
  }

  &__button {
    cursor: pointer;
    margin-top: 30px;
    padding: 12px 40px;
    border-radius: 8px;
    background-color: #484848;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: 0.2s;

    color: #FFF;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;

    @include hover {
      background-color: #696969;
    }

    &:disabled {
      cursor: not-allowed;
      background-color: #363636;

      @include hover {
        background-color: #363636;
      }
    }
  }
}

@media (max-width: 850px) {
  .login {
    &__form {
      width: 100%;
      margin-top: 100px;
    }
  }
}

@media (max-width: 500px) {
  .login {
    &__logo {
      width: 100px;
    }

    &__form {
      margin-top: 50px;
    }

    &__footer {
      &-text {
        font-size: 12px;
      }
    }
  }
}
</style>